import { Box, Button, Chip, Grid, Typography } from '../../imports/muiImport';
import { NavLink } from 'react-router-dom';
import { titleToUrl } from '../../shared/extra';
import { useEffect } from 'react';

const getPreviewText = (htmlContent, maxLength = 150) => {
    if (!htmlContent) return '';
    const plainText = htmlContent.replace(/<[^>]+>/g, '');
    return plainText.length > maxLength ? plainText?.slice(0, maxLength) + '...' : plainText;
};

const BlogCard = ({ data }) => {
     useEffect(()=>{
        window.scrollTo(0, 0);
  },[])
    return (
        <Grid item xs={12} sm={6} md={6} lg={4}>
            <Box
                sx={{
                    background: '#ffff',
                    borderRadius: 3,
                    boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                    overflow: 'hidden',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    transition: 'all 0.3s ease',
                    cursor: 'pointer',

                    '&:hover': {
                        transform: 'translateY(-8px)',
                        boxShadow: '0 12px 25px rgba(0,0,0,0.15)',
                    },
                }}
            >
                {/* Image Section */}
                <Box
                    sx={{
                        height: 220,
                        width: '100%',
                        overflow: 'hidden',
                        borderRadius: '12px',
                        padding: 2,
                    }}
                >
                    <NavLink
                        to={`/blog-details/${titleToUrl(data?.title)}`}
                        style={{ textDecoration: 'none' }}
                    >
                        <Box
                            component="img"
                            src={data?.posterImage}
                            alt="Blog Banner"
                            loading="lazy"
                            sx={{
                                width: '100%',
                                height: '100%',
                                borderRadius: 4,
                                objectFit: 'cover',
                                transition: 'transform 0.4s ease',

                                '.MuiBox-root:hover &': {
                                    transform: 'scale(1.06)',
                                },
                            }}
                        />
                    </NavLink>

                    {/* Category Chip */}
                    {data?.category && (
                        <Chip
                            label={data.category}
                            sx={{
                                position: 'absolute',
                                top: 12,
                                right: 12,
                                background: 'red',
                                color: '#fff',
                                fontWeight: 600,
                                fontSize: '12px',
                            }}
                        />
                    )}
                </Box>

                {/* Content Section */}
                <Box sx={{ p: 2 }}>
                    <NavLink
                        to={`/blog-details/${titleToUrl(data?.title)}`}
                        style={{ textDecoration: 'none' }}
                    >
                        <Typography
                            variant="h4"
                            sx={{
                                fontSize: '18px',
                                fontWeight: 600,
                                color: 'dark.main',
                                mb: 1,
                                display: '-webkit-box',
                                WebkitBoxOrient: 'vertical',
                                WebkitLineClamp: 2,
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                            }}
                        >
                            {data?.title}
                        </Typography>
                    </NavLink>

                    {data?.tag && (
                        <Chip
                            label={data.tag}
                            sx={{
                                mb: 1,
                                background: '#e8f0ff',
                                fontWeight: 600,
                            }}
                        />
                    )}

                    <Typography
                        sx={{
                            fontSize: '14px',
                            color: 'textPrimary.main',
                            lineHeight: '22px',
                            mb: 2,
                        }}
                    >
                        {getPreviewText(data?.content)}
                    </Typography>

                    <NavLink
                        to={`/blog-details/${titleToUrl(data?.title)}`}
                        style={{ textDecoration: 'none' }}
                    >
                        <Button
                            sx={{
                                textTransform: 'none',
                                fontSize: '14px',
                                fontWeight: 600,
                                px: 0,
                            }}
                        >
                            Read Full Blog →
                        </Button>
                    </NavLink>
                </Box>
            </Box>
        </Grid>
    );
};

export default BlogCard;
